import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';

export const platformControlRouteRef = createRouteRef();

const platformControlPage = PageBlueprint.make({
  params: {
    path: '/platform',
    title: 'Platform Control',
    icon: <SettingsInputComponentIcon fontSize="small" />,
    routeRef: platformControlRouteRef,
    loader: () =>
      import('./PlatformControlPage').then(module => (
        <module.PlatformControlPage />
      )),
  },
});

export const platformControlPlugin = createFrontendPlugin({
  pluginId: 'platform-control',
  title: 'Platform Control',
  icon: <SettingsInputComponentIcon fontSize="small" />,
  routes: { root: platformControlRouteRef },
  extensions: [platformControlPage],
});
